'use strict';

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { getVisitChangesFromResults, getVisitorChanges } from './utils';
import { TrackedActivityResults } from '../models/trackedActivity';
import { getNullLogger } from '@uniformdev/common';
import { getSubscriptionManager } from '@uniformdev/optimize-common-sitecore';
var version = require('../build/version.json');
/**
 * Default implementation of the Uniform tracker.
 */
var DefaultTracker = /** @class */function () {
  function DefaultTracker(id, settings) {
    var _a, _b, _c, _d, _e;
    this.contextReaders = new Map();
    this.state = 'unknown';
    this.id = id;
    this.contextReaders = (_a = settings.contextReaders) !== null && _a !== void 0 ? _a : new Map();
    this.dispatchers = (_b = settings.dispatchers) !== null && _b !== void 0 ? _b : [];
    this.onDispatch = settings.onDispatch;
    this.onBeforeDispatchData = settings.onBeforeDispatchData;
    this.logger = (_c = settings.logger) !== null && _c !== void 0 ? _c : getNullLogger();
    this.extensions = settings.extensions;
    this.repository = settings.repository;
    this.sessionTimeout = (_d = settings.sessionTimeout) !== null && _d !== void 0 ? _d : 20;
    this.subscriptions = (_e = settings.subscriptions) !== null && _e !== void 0 ? _e : getSubscriptionManager("".concat(id, "_SUBS"), false, this.logger);
    this.version = version.version;
  }
  DefaultTracker.prototype.event = function (type, e, settings) {
    return __awaiter(this, void 0, void 0, function () {
      var callback, results;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logger.debug('Default tracker - START: event() handling.', {
              event: e,
              settings: settings
            });
            callback = function callback(_date, activity) {
              switch (type) {
                case "visit-activity":
                  activity.visitActivities.push(e);
                  break;
                case "visit-update":
                  activity.visitUpdates.push(e);
                  break;
                case "visitor-update":
                  activity.visitorUpdates.push(e);
                  break;
                default:
                  _this.logger.error("Default tracker - Specified event type is not supported. Event will not be captured.", {
                    type: type,
                    event: e
                  });
              }
            };
            return [4 /*yield*/, this.doWork("tracking-finished", __assign(__assign({}, settings), {
              event: true
            }), callback)];
          case 1:
            results = _a.sent();
            this.logger.debug('Default tracker - END: event() handling.', {
              results: results
            });
            return [2 /*return*/, results];
        }
      });
    });
  };
  DefaultTracker.prototype.initialize = function (settings) {
    return __awaiter(this, void 0, void 0, function () {
      var results;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logger.debug('Default tracker - START: initialize() handling.', {
              settings: settings
            });
            return [4 /*yield*/, this.doWork("tracking-intialized", settings, function (_date, _activity) {})];
          case 1:
            results = _a.sent();
            this.logger.debug('Default tracker - END: initialize() handling.', {
              results: results
            });
            return [2 /*return*/, results];
        }
      });
    });
  };
  DefaultTracker.prototype.subscribe = function (type, callback) {
    this.logger.debug("Default tracker - Add subscription.", {
      manager: this.subscriptions.id,
      type: type
    });
    return this.subscriptions.subscribe(type, callback);
  };
  DefaultTracker.prototype.track = function (source, context, settings) {
    return __awaiter(this, void 0, void 0, function () {
      var callback, results;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logger.debug('Default tracker - START: track() handling.', {
              source: source,
              context: context,
              settings: settings
            });
            callback = function callback(date, activity) {
              var visit = activity.visit,
                visitor = activity.visitor;
              //
              //Get the url
              var url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
              //
              //Make sure at least one context reader is available.
              var readers = source ? _this.contextReaders.get(source) : undefined;
              if (!readers) {
                _this.logger.warn('Default tracker -   * No context readers are registered for the source. No tracking data will be created.', {
                  source: source
                });
                return;
              }
              //
              //Use the context reader to determine the tracked activity.
              var readerContext = {
                date: date,
                context: context,
                visit: visit,
                visitor: visitor,
                url: url,
                logger: _this.logger
              };
              _this.logger.debug("Default tracker -   * Iterate context readers to read activity from context.", {
                context: context
              });
              _this.contextReaders.forEach(function (readers, id) {
                _this.logger.debug('Default tracker -   * Reading activity from context using context readers.', {
                  id: id,
                  readers: readers
                });
                readers.forEach(function (reader) {
                  var activity2 = reader.getTrackedActivity(source, readerContext);
                  _this.logger.debug('Default tracker -      * Activity read from reader.', {
                    type: reader.type,
                    activity: activity2
                  });
                  activity.append(activity2);
                });
              });
            };
            return [4 /*yield*/, this.doWork("tracking-finished", settings, callback)];
          case 1:
            results = _a.sent();
            this.logger.debug('Default tracker - END: track() handling.', {
              results: results
            });
            return [2 /*return*/, results];
        }
      });
    });
  };
  DefaultTracker.prototype.doDispatch = function (activity, settings, visitor) {
    var _this = this;
    //
    //Dispatch the results if any dispatchers are specified.
    if (this.dispatchers && this.dispatchers.length > 0) {
      this.logger.debug('Default tracker -   * Dispatchers are defined, so call them.', {
        visitorId: visitor.id,
        dispatchers: this.dispatchers
      });
      var isRunningInBrowser_1 = typeof window !== 'undefined' && window.document != undefined;
      this.dispatchers.forEach(function (dispatcher) {
        if (!dispatcher.requiresBrowser || isRunningInBrowser_1) {
          _this.logger.debug("Default tracker -   START: activity dispatch.", {
            visitorId: visitor.id,
            type: dispatcher.type,
            activity: activity
          });
          dispatcher.dispatchActivity(activity, settings, _this.logger);
          _this.logger.debug("Default tracker -   END: activity dispatch.", {
            visitorId: visitor.id,
            type: dispatcher.type,
            activity: activity
          });
        }
      });
    }
    //
    //Dispatch using the event handler if the handler is specified.
    if (this.onDispatch) {
      this.logger.debug("Default tracker -   START: dispatch event handler.", {
        activity: activity,
        settings: settings
      });
      this.onDispatch(activity, settings, this.logger);
      this.logger.debug("Default tracker -   END: dispatch event handler.");
    }
  };
  DefaultTracker.prototype.doVisitUpdate = function (date, activity, visit) {
    //
    //Update the visit.
    if (activity.visitActivities.length > 0 || activity.visitUpdates.length > 0) {
      visit.updated = date;
    }
    if (!visit.data) {
      visit.data = {};
    }
    if (!visit.data["activities"]) {
      visit.data["activities"] = [];
    }
    //
    //
    if (activity.visitActivities.length === 0) {
      this.logger.debug('Default tracker -   * No visit activities to add to visit.', {
        visit: visit,
        activities: activity.visitActivities
      });
    } else {
      this.logger.debug('Default tracker -   * Adding visit activities to visit.', {
        visit: visit,
        activities: activity.visitActivities
      });
      activity.visitActivities.forEach(function (activity) {
        visit.data["activities"].push(activity);
      });
      this.logger.debug('Default tracker -   * Visit activities added to visit.', {
        visit: visit,
        activities: activity.visitActivities
      });
    }
    //
    //
    if (activity.visitUpdates.length === 0) {
      this.logger.debug('Default tracker -   * No visit data to add to visit.', {
        visit: visit,
        data: activity.visitUpdates
      });
    } else {
      this.logger.debug('Default tracker -   * Apply visit updates.', {
        visit: visit.id,
        count: activity.visitUpdates.length
      });
      this.applyUpdatesToTarget(date, activity.visitUpdates, visit);
    }
    //
    //
    if (activity.visitUpdateCommands.length === 0) {
      this.logger.debug('Default tracker -   * No visit update commands to run.', {
        visit: visit.id
      });
    } else {
      this.logger.debug('Default tracker -   * Run visit update commands.', {
        visit: visit.id,
        commands: activity.visitUpdateCommands
      });
      activity.visitUpdateCommands.forEach(function (command) {
        command(visit);
      });
    }
  };
  DefaultTracker.prototype.doVisitorUpdate = function (date, activity, visitor) {
    //
    //Update the visitor.
    if (!visitor.data) {
      visitor.data = {};
    }
    if (activity.visitorUpdates.length === 0) {
      this.logger.debug('Default tracker -   * No visitor updates to apply.', {
        visitor: visitor.id
      });
    } else {
      this.logger.debug('Default tracker -   * Apply visitor updates.', {
        visitor: visitor.id,
        count: activity.visitorUpdates.length
      });
      this.applyUpdatesToTarget(date, activity.visitorUpdates, visitor);
    }
    if (activity.visitorUpdateCommands.length === 0) {
      this.logger.debug('Default tracker -   * No visitor update commands to run.', {
        visitor: visitor.id
      });
    } else {
      this.logger.debug('Default tracker -   * Run visitor update commands.', {
        visitor: visitor.id,
        commands: activity.visitorUpdateCommands
      });
      activity.visitorUpdateCommands.forEach(function (command) {
        command(visitor);
      });
    }
  };
  /**
   * Update values for profiles, patterns and other properties of the target.
   * @param date
   * @param updates
   * @param target
   */
  DefaultTracker.prototype.applyUpdatesToTarget = function (date, updates, target) {
    var _this = this;
    updates.forEach(function (update) {
      _this.logger.debug('Default tracker -     * Applying update to target.', {
        target: target.id,
        update: update
      });
      if (target.data[update.type]) {
        //
        //target.data["profile"].["key"] exists, update it
        target.data[update.type].date = date;
        Object.keys(update.data).forEach(function (profileOrPatternKey) {
          target.data[update.type].data[profileOrPatternKey] = update.data[profileOrPatternKey];
        });
      } else {
        //
        //target.data["profile"].["key"] doesn't exist, add it
        target.data[update.type] = {
          date: date,
          data: update.data
        };
      }
    });
  };
  DefaultTracker.prototype.doWork = function (eventType, settings, callback) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var visitorId, visitId, _b, createVisitor, onVisitorInitialized, visitor, visit, activity, date, saveVisitor, result, now, visitChanges, visitorChanges, when, hasChanges, trackingFinishedEvent, types, dispatchSettings, ex_1;
      var _this = this;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            visitorId = settings.visitorId, visitId = settings.visitId, _b = settings.createVisitor, createVisitor = _b === void 0 ? false : _b, onVisitorInitialized = settings.onVisitorInitialized;
            visitor = undefined;
            visit = undefined;
            activity = new TrackedActivityResults();
            date = new Date().toISOString();
            //
            //
            this.logger.debug('Default tracker -   START: doWork.', {
              eventType: eventType,
              settings: settings
            });
            _c.label = 1;
          case 1:
            _c.trys.push([1, 4, 5, 6]);
            //
            //Get the visitor.
            if (!visitorId) {
              this.logger.debug('Default tracker -   * No visitor id was set on the tracking settings, so will try to create new visitor.', {
                settings: settings
              });
            } else {
              this.logger.debug('Default tracker -   * Get visitor from the repository using visitor id set on the tracking settings.', {
                visitorId: visitorId
              });
              visitor = this.repository.getVisitor(visitorId);
              if (!visitor) {
                this.logger.debug('Default tracker -   * No visitor was returned from the repository.', {
                  visitorId: visitorId
                });
              }
            }
            if (!visitor) {
              if (!createVisitor) {
                this.logger.warn('Default tracker -   * No visitor was resolved and the create-visitor flag was not set on the tracking settings. Tracking will abort.', {
                  settings: settings
                });
                return [2 /*return*/, activity];
              }
              //
              //Create a new visitor.
              visitor = this.repository.createVisitor();
              if (!visitor) {
                this.logger.error('Default tracker -   * Unable to create new visitor. Tracking will abort.');
                return [2 /*return*/, activity];
              }
              this.logger.debug('Default tracker -   * New visitor was created.', {
                visitorId: visitor.id
              });
            } else {
              this.logger.debug('Default tracker -   * Visitor was retrieved from the repository.', {
                visitorId: visitorId
              });
            }
            if (!onVisitorInitialized) return [3 /*break*/, 3];
            this.logger.debug('Default tracker -   * Event handler for visitor-initialized event was specified on the tracking settings, so call it.');
            saveVisitor = function saveVisitor(date, visitor, visitChanges, visitorChanges) {
              _this.logger.debug('Default tracker - Save visitor was called by the visitor-initialized event handler specified on the tracking settings.');
              _this.repository.saveVisitor(date, visitor, visitChanges, visitorChanges, settings === null || settings === void 0 ? void 0 : settings.silent);
            };
            return [4 /*yield*/, onVisitorInitialized(visitor, saveVisitor, this.logger)];
          case 2:
            _c.sent();
            this.logger.debug('Default tracker -   * Event handler for visitor-initialized event specified on the tracking settings finished.');
            _c.label = 3;
          case 3:
            result = this.repository.getCurrentVisit({
              visitId: visitId,
              visitor: visitor,
              sessionTimeout: this.sessionTimeout,
              forceNew: settings.isNew,
              when: settings.lastActivity ? new Date(settings.lastActivity) : undefined
            });
            visit = result.current;
            if (!visit) {
              this.logger.error('Default tracker -   * No visit was returned from the repository. Tracking will abort.');
              return [2 /*return*/, activity];
            }
            if (result.isNewVisit && ((_a = this.extensions) === null || _a === void 0 ? void 0 : _a.onNewVisitCreated)) {
              this.logger.debug('Default tracker -   * Event handler for new-visit-created event was specified on extensions on the tracking settings, so call it.', {
                settings: settings
              });
              now = new Date();
              this.extensions.onNewVisitCreated(now, visitor, result.previous, visit, this.logger);
            }
            //
            //
            activity.visit = visit;
            activity.visitor = visitor;
            //
            //
            callback(date, activity);
            visitChanges = getVisitChangesFromResults(activity, visit, visitor);
            this.logger.debug('Default tracker -   * Resolved visit changes from results.', {
              visitChanges: visitChanges,
              activity: activity,
              visit: visit,
              visitor: visitor
            });
            visitorChanges = getVisitorChanges(activity, visit, visitor);
            this.logger.debug('Default tracker -   * Resolved visitor changes from results.', {
              visitorChanges: visitorChanges,
              activity: activity,
              visit: visit,
              visitor: visitor
            });
            //
            //
            if (visitChanges.size == 0 && visitorChanges.length == 0) {
              this.logger.debug('Default tracker -   * No changes were made to the visit or the visitor, so there is nothing to track.', {
                activity: activity
              });
              return [2 /*return*/, activity];
            }
            this.doVisitUpdate(date, activity, visit);
            this.doVisitorUpdate(date, activity, visitor);
            when = new Date();
            if (this.extensions && this.extensions.onBeforeVisitorSaved) {
              this.logger.debug('Default tracker -   * Event handler for before-visitor-saved event was specified on extensions on the tracking settings, so call it.', {
                settings: settings
              });
              this.extensions.onBeforeVisitorSaved(when, visitor, visitChanges, visitorChanges, this.logger);
            }
            hasChanges = visitorChanges.length > 0 || visitChanges.size > 0;
            if (!hasChanges) {
              this.logger.debug('Default tracker -   * No visitor or visit changes were resolved, so no changes will be saved to the repository.', {
                visitor: visitor.id,
                visit: visit.id
              });
            } else {
              //
              //Save the visitor to persistent storage using the 
              //repository. The repository may trigger events to 
              //notify subscribers that something has changed.
              this.logger.debug('Default tracker -   START: saving visitor.', {
                visitorId: visitor.id,
                when: when,
                visitorChanges: visitorChanges,
                visitChanges: visitChanges
              });
              this.repository.saveVisitor(when, visitor, visitChanges, visitorChanges, settings === null || settings === void 0 ? void 0 : settings.silent);
              this.logger.debug('Default tracker -   END: saving visitor.', {
                visitorId: visitor.id
              });
            }
            //
            //Update global objects.
            if (!window.uniform) {
              this.logger.debug("Default tracker -   * Global Uniform object does not exist, so creating it.", {
                visit: visit,
                visitor: visitor
              });
              window.uniform = {};
            }
            this.logger.debug("Default tracker -   * Updating global Uniform object.", {
              tracker: this.id,
              visitor: visitor.id,
              visit: visit.id
            });
            window.uniform.tracker = this;
            window.uniform.visit = visit;
            window.uniform.visitor = visitor;
            if (settings.silent !== true) {
              trackingFinishedEvent = {
                type: eventType,
                when: new Date(),
                visit: activity.visit,
                visitor: activity.visitor
              };
              types = this.subscriptions.getSubscriptionTypes();
              if (!types.includes(trackingFinishedEvent.type)) {
                this.logger.debug("Default tracker -   * An event will be fired, but the subscription manager is not listening for it.", {
                  manager: this.subscriptions.id,
                  event: trackingFinishedEvent,
                  types: this.subscriptions.getSubscriptionTypes()
                });
              }
              this.logger.debug("Default tracker -   * Notify subscribers that tracking is finished.", {
                manager: this.subscriptions.id,
                event: trackingFinishedEvent,
                types: this.subscriptions.getSubscriptionTypes(),
                settings: settings
              });
              this.subscriptions.publish(trackingFinishedEvent);
            } else {
              this.logger.debug("Default tracker -   * Tracking settings indicate silent mode. Tracking is finished but subscribers will not be notified.", {
                manager: this.subscriptions.id
              });
            }
            //
            //Do dispatch
            if (hasChanges) {
              dispatchSettings = {
                event: settings.event,
                onBeforeDispatchData: this.onBeforeDispatchData
              };
              this.doDispatch(activity, dispatchSettings, visitor);
            }
            return [3 /*break*/, 6];
          case 4:
            ex_1 = _c.sent();
            this.logger.error('Default tracker -   * Error thrown.', {
              ex: ex_1
            });
            return [3 /*break*/, 6];
          case 5:
            this.logger.debug('Default tracker -   END: doWork.', {
              settings: settings
            });
            this.state = 'ready';
            return [7 /*endfinally*/];
          case 6:
            return [2 /*return*/, activity];
        }
      });
    });
  };
  return DefaultTracker;
}();
export { DefaultTracker };